import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface SidebarShellProps {
  /** Genişlik ve etiket görünürlüğünü belirler — §3: 248px açık / 72px daralmış. */
  collapsed: boolean;
  /** Üstteki marka bloğu (logo + wordmark). Domain BİLMEZ: çağıran hazır JSX verir. */
  logo: ReactNode;
  /** Gezinme öğeleri — hangi öğelerin görüneceği domain kararı, burada yalnız yerleşim. */
  children: ReactNode;
  /** Alttaki sabit blok (mockup: "Menüyü Daralt" kontrolü). */
  footer?: ReactNode;
  className?: string;
}

/**
 * Sidebar KABUĞU (çerçeve) — UI Tur 2 §4/§10.5. Hangi gezinme öğelerinin göründüğü bir
 * DOMAIN kararı (yetki, çalışma alanı türü — `apps/web/src/lib/navigation.ts`) ve bu
 * paket domain BİLMEZ (`packages/ui/CLAUDE.md`); o yüzden öğe listesi `children` olarak
 * dışarıdan geliyor. Bu bileşen yalnız "sidebar nasıl görünür" sorusuna cevap veriyor:
 * genişlik, kenarlık, marka/gezinme/altbilgi dikey yerleşimi.
 */
export function SidebarShell({ collapsed, logo, children, footer, className }: SidebarShellProps) {
  return (
    <aside
      className={cn(
        "flex shrink-0 flex-col border-r border-border-default bg-surface transition-[width]",
        collapsed ? "w-[72px]" : "w-[248px]",
        className,
      )}
    >
      {/**
       * ⚠ Bu sarmalayıcılar KENDİ dolgusunu TAŞIMAZ: `children` domaindeki `<nav
       * aria-label="Ana gezinme">` zaten kendi `px-3 py-4 gap-1`'ini taşıyor (§4 aynı
       * ölçüler) — burada tekrarlansaydı iç içe dolgu doğar, gezinme kutunun içinde
       * asimetrik görünürdü.
       */}
      <div className="px-3">{logo}</div>
      <div className="flex flex-1 flex-col overflow-y-auto">{children}</div>
      {footer ? <div className="px-3 pb-4">{footer}</div> : null}
    </aside>
  );
}
